<script setup lang="ts">
import { components } from '~/slices'

const { client } = usePrismic()
const { data: page } = await useAsyncData('index', () =>
  client.getByUID('page', 'home'),
)

useDocumentSeo(page)
</script>

<template>
  <main>
    <SliceZone :slices="page?.data.slices ?? []" :components="components" />
  </main>
</template>
